import { Button, Input, message, Modal, Popover, Space, Switch, Table, Upload } from "antd";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
    EditOutlined,
    DeleteOutlined,
    UploadOutlined
  } from '@ant-design/icons';
  import {baseUrl} from "../../../../src/config"
export const Portfolio=()=>{
const [services,setServices]=useState([])
const [serviceReq,setServiceReq]=useState({
    title:"",
    description:"",
    profile:""
})
const [modalVisibility,setModalVisibility]=useState("")
     
const { Column, ColumnGroup } = Table;

interface DataType {
  key: React.Key;
  firstName: string;
  lastName: string;
  age: number;
  address: string;
  tags: string[];
}
const storedData = localStorage.getItem("loginData");
const loginData = JSON.parse(storedData);
const navigate=useNavigate()
const handlePreview = (file) => {
    const reader = new FileReader();
    reader.onload = () => {
      const image: any = new Image();
      image.src = reader.result;
      document.body.append(image);
    };
    reader.readAsDataURL(file.originFileObj); // Read the file as data URL
  };
  const handleFileChange = ({ fileList }) => {
    console.log("File uploaded: ", fileList);
    if (fileList && fileList.length > 0) {
      const file = fileList[0].originFileObj;
      const reader = new FileReader();
      reader.onloadend = () => {
        setServiceReq({
          ...serviceReq,
          profile: reader.result as string, // Set the profile picture as Base64 string
        });
      };
      reader.readAsDataURL(file); // Convert the image to Base64
    }
  };
    useEffect(() => {
        const storedData = localStorage.getItem("loginData");
        if (storedData) {
            // Parse the data into an object
            const loginData = JSON.parse(storedData);
          
            // Access the id from the stored data
            const userId = loginData.id;
          
            console.log("User ID:", userId);
          } else {
            console.log("No login data found");
          }
        getServices();
      }, []);
    
      const getServices = async () => {
        try {
          const resp = await axios.get(
            `${baseUrl}account/${loginData.id}/services`,
            {
              headers:{
                  Authorization:`Bearer ${loginData.authToken}`
              }
          }
          );
          console.log(resp.data); // Log the response to check
        
          setServices(resp?.data);
        } catch (e) {
           if(e.response.status==401){
                          navigate("/admin/login")
                      }
          console.error(e);
        }
      }

      const updateService = async () => {
        try {
          const resp = await axios.put(
            `${baseUrl}account/${loginData.id}/service/update`,serviceReq,{
                headers:{
                    Authorization:`Bearer ${loginData.authToken}`
                }
            }
          );
          if(resp){
            
            message.success("Service updated successfully")
            setModalVisibility("")
            getServices()
          }
        
        } catch (e) {
          console.error(e);
           if(e.response.status==401){
                          navigate("/admin/login")
                      }
          message.error("Failed to update service")
        }
      }
      const createService = async () => {
        try {
          const resp = await axios.post(
            `${baseUrl}account/${loginData.id}/service/create`,serviceReq,{
                headers:{
                    Authorization:`Bearer ${loginData.authToken}`
                }
            }
          );
          if(resp){
            message.success("Service created successfully")
            setModalVisibility("")
            getServices()
          }
        
        } catch (e) {
          console.error(e);
           if(e.response.status==401){
                          navigate("/admin/login")
                      }
          message.error("Failed to create service")
        }
      }
      const deleteService = async (id) => {
        try {
          const resp = await axios.delete(
            `${baseUrl}account/${loginData.id}/services/${id}`,{
                headers:{
                    Authorization:`Bearer ${loginData.authToken}`
                }
            }
          );
          if(resp){
            message.success("Service deleted successfully")
            getServices()
          }
        
        } catch (e) {
          console.error(e);
          message.error("Failed to delete service")
          if(e.response.status==401){
            navigate("/admin/login")
        }
        }
      }
    return(
      <div>
      <div style={{display:"flex", justifyContent:"center", alignItems:"center", marginBottom: 24, position: "relative"}}>
  <div style={{textAlign:"center", fontSize:28, fontWeight:600, flex: 1}}>Portfolio</div>
  <Button
    style={{
      padding: 10,
      background: "#f7941d",
      color: "#fff",
      position: "absolute",
      right: 0,
    }}
    onClick={() => { setModalVisibility("create"); setServiceReq(null); }}
  >
    CREATE
  </Button>
</div>
      <Table<DataType> dataSource={services}  pagination={{ pageSize: 20 }}>
<Column title="Title" dataIndex="title" key="title" />
<Column
        title="Description"
        dataIndex="description"
        key="description"
        ellipsis
        render={(text) => (
          <div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
            {text}
          </div>
        )}
      />
<Column
title="Profile"
dataIndex="profile"
key="profile"
render={(profile: string) => (
 <>
<Popover content={<div>{profile ?<img src={profile} style={{width:"200",height:"200px"}}></img>:"No Data"}</div>} trigger="click" ><div style={{color:"green",cursor:"pointer"}}>View profile</div></Popover>
 </>
)}
/>
<Column
title="Action"
key="action"
render={(_: any, record: any) => (
 <Space size="middle">
    <EditOutlined onClick={()=>{setServiceReq(record);setModalVisibility("update")}}/>


   <DeleteOutlined  color="#FFF" style={{color:"red"}}  onClick={()=>deleteService(record?.id)}/>
 </Space>
)}
/>
</Table>
<Modal
      title={modalVisibility=="create"?"Create Service":"Update Service"}
      visible={modalVisibility ? true:false}
      onCancel={() => setModalVisibility("")}
      footer={[
        <Button key="cancel" onClick={() => setModalVisibility("")}>
          Cancel
        </Button>,
        <Button key="update" type="primary" onClick={()=>modalVisibility=="create"? createService():updateService()}>
          Update
        </Button>,
      ]}
    >
      <div>
        <div style={{ marginBottom: 10 }}>
          <div >Title*</div>
          <Input
            value={serviceReq?.title}
            onChange={(e) => setServiceReq({ ...serviceReq, title: e.target.value })}
            placeholder="Title"
            style={{ marginTop: 5 }}
          />
        </div>

        <div style={{ marginBottom: 10 }}>
          <div >Description*</div>
          <Input
            value={serviceReq?.description}
            onChange={(e) => setServiceReq({ ...serviceReq, description: e.target.value })}
            placeholder="Description"
            style={{ marginTop: 5 }}
          />
        </div>

        <div style={{ marginBottom: 10 }}>
          <div >Profile Image*</div>
          <Upload
            accept="image/*"
            showUploadList={false}
            beforeUpload={() => false} // Disable automatic upload
            onChange={handleFileChange}
            onPreview={handlePreview}
            maxCount={1} // Limit to 1 file
          >
            <Button icon={<UploadOutlined />}>Upload Image</Button>
          </Upload>
        </div>

        {serviceReq?.profile && (
          <div style={{ marginTop: 10 }}>
            <img src={serviceReq?.profile} alt="Uploaded" style={{ width: 100, height: 100 }} />
          </div>
        )}
      </div>
    </Modal>
 </div>
    )
}